import {
  CalendarCheck,
  Sparkles,
  GraduationCap,
  Trophy,
  ShieldCheck,
  Users,
  Blocks,
  MapPin,
  Rocket,
  Wrench,
  Star,
  Lightbulb,
  Brain,
  Palette,
  Monitor,
} from 'lucide-react';

export const HOME_ICONS = {
  CalendarCheck,
  Sparkles,
  GraduationCap,
  Trophy,
  ShieldCheck,
  Users,
  Blocks,
  MapPin,
  Rocket,
  Wrench,
  Star,
  Lightbulb,
  Brain,
  Palette,
  Monitor,
};

export const resolveHomeIcon = (name) => HOME_ICONS[name] || Sparkles;
